import * as types from '../constants/actionTypes';

const initialState = {
  vendors: [],
  currentVendor: null,
  loading: false,
  error: null
};

const vendorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_VENDORS_REQUEST:
    case types.FETCH_VENDOR_REQUEST:
    case types.CREATE_VENDOR_REQUEST:
    case types.UPDATE_VENDOR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.FETCH_VENDORS_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: action.payload,
        error: null
      };

    case types.FETCH_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        currentVendor: action.payload,
        error: null
      };

    case types.CREATE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: [...state.vendors, action.payload],
        error: null
      };

    case types.UPDATE_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: state.vendors.map(vendor => 
          vendor.id === action.payload.id ? action.payload : vendor
        ),
        error: null
      };


    case types.FETCH_VENDORS_FAILURE:
    case types.FETCH_VENDOR_FAILURE:
    case types.CREATE_VENDOR_FAILURE:
    case types.UPDATE_VENDOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default vendorReducer;